import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Chip, Box, IconButton, Typography
} from "@mui/material";
import { Close } from "@mui/icons-material";

// Simple email validation function
const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const ParticipantsDialog = ({ open, onClose, emails, setEmails }: any) => {
  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");


  const addEmailsFromInput = () => {
    const potentialEmails = inputValue.trim().split(/\s+/).filter(Boolean);
  
    if (potentialEmails.length === 0) return;
  
    const newValidEmails: string[] = [];
    const errors: string[] = [];
  
    potentialEmails.forEach((email) => {
      if (!isValidEmail(email)) {
        errors.push(`${email} is invalid`);
      } else if (emails.includes(email)) {
        errors.push(`${email} is already added`);
      } else {
        newValidEmails.push(email);
      }
    });
  
    if (newValidEmails.length > 0) {
      setEmails([...emails, ...newValidEmails]);
      setInputValue("");
    }
  
    if (errors.length > 0) {
      setErrorMessage(errors.join(", "));
    } else {
      setErrorMessage("");
    }
  };
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setErrorMessage(""); // clear previous error
    if (val.endsWith(" ")) {
      setInputValue(val);
      addEmailsFromInput();
    } else {
      setInputValue(val);
    }
  };
  

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addEmailsFromInput();
    }
  };

  const handleDelete = (emailToDelete: string) => {
    setEmails(emails.filter((email: string) => email !== emailToDelete));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        Add Participants
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
  <Typography variant="subtitle2" mb={1}>Enter email (Press Space or Enter):</Typography>
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 1,
      border: "1px solid #ccc",
      borderRadius: 1,
      padding: "6px 8px",
      minHeight: "56px"
    }}
  >
    {emails.map((email: string, index: number) => (
      <Chip
        key={index}
        label={email}
        onDelete={() => handleDelete(email)}
        sx={{ height: "32px" }}
      />
    ))}
    <input
      type="text"
      value={inputValue}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      placeholder="Type email..."
      style={{
        border: "none",
        outline: "none",
        flex: 1,
        minWidth: "120px",
        fontSize: "16px"
      }}
    />
    {errorMessage && (
  <Typography color="error" mt={1} fontSize="14px">
    {errorMessage}
  </Typography>
)}

  </Box>
</DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ParticipantsDialog;
